import { CrewMemberAssignment, Owner, OwnerDetails, QuantitySummary } from "@bechtel/types";

export interface WorkPackageQuantityStatsProps {
  label: string;
  value: string;
  onClick: () => void;
}

export interface WorkPackageQuantityStatsSideSheetProps {
  workPackageId: string;
  isUnitOfMeasureHour: boolean;
  onClose: () => void;
}

export interface WorkPackageOwnerComponentProps {
    owner?: Owner | null;
    isUnitOfMeasureHour: boolean;
}

export interface QuantityStatValuesProps {
    totalQuantity?: QuantitySummary;
    isUnitOfMeasureHour: boolean;
    backgroundColor?: any;
    color?: string
}

export interface OwnerSectionComponentProps {
    title: string;
    ownerDetails?: OwnerDetails;
    isUnitOfMeasureHour: boolean;
}